export default __webpack_public_path__ + "static/media/add.5922b7b7.svg";